import { styled } from '@mui/material'

// Global UI
import { TypographyH2, TypographyP } from '@/ui'

export const AskUsAnythingH2 = styled(TypographyH2)(({ theme }) => ({
  color: '#333333',
  fontSize: theme.typography.pxToRem(36),
  lineHeight: '1.2em',
  fontWeight: 600,
  margin: 0,
  padding: 0,
  textTransform: 'capitalize',
}))

export const LoveToHearP = styled(TypographyP)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(24),
  lineHeight: theme.typography.pxToRem(33),
  color: '#777777',
  fontWeight: 500,
}))

export const HeadOfficeH2 = styled(TypographyH2)(({ theme }) => ({
  color: '#333333',
  fontSize: theme.typography.pxToRem(30),
  fontWeight: 600,
  lineHeight: theme.typography.pxToRem(44),
  margin: 0,
  padding: 0,
  textTransform: 'capitalize',
}))

export const AddressP = styled(TypographyP)(({ theme }) => ({
  color: '#7a7a7a',
  fontSize: theme.typography.pxToRem(18),
  fontWeight: 300,
  lineHeight: theme.typography.pxToRem(24),
  margin: 0,
  padding: 0,
  fontStyle: 'italic',
}))

export const DiscussProjectH2 = styled(TypographyH2)(({ theme }) => ({
  color: '#333333',
  fontSize: theme.typography.pxToRem(35),
  lineHeight: '1.5em',
  fontWeight: 600,
}))
